<div [ngStyle]="cellStyles">
    <span>{{params.value}}</span>
</div>
